import * as React from 'react';
import { useLocation } from 'react-router';
import { ExtensionSlot } from 'piral-core';
import { BreadcrumbItem, BreadcrumbsContainer } from '@smapiot/components';
import { Content } from './Content';
import { breadcrumbs } from '../routes';

function getNext(path: string) {
  if (path) {
    const [bc] = breadcrumbs.filter((m) => m.path === path);
    return bc;
  }

  return undefined;
}

function getBreadcrumbs(path: string) {
  const current = getNext(path) || breadcrumbs[0];
  const links = [];
  let previous = getNext(current.parent);

  while (previous !== undefined) {
    links.push({
      url: previous.path,
      title: previous.title,
    });
    previous = getNext(previous.parent);
  }

  return {
    previous: links.reverse(),
    current: current.title,
  };
}

const AnonymousBreadcrumbs: React.FC = () => {
  const location = useLocation();
  const breadcrumbs = getBreadcrumbs(location.pathname);

  return (
    <p>
      <BreadcrumbsContainer hidden={breadcrumbs.previous.length === 0}>
        <>
          {breadcrumbs.previous.map((bc) => (
            <BreadcrumbItem path={bc.url}>{bc.title}</BreadcrumbItem>
          ))}
          <BreadcrumbItem current>{breadcrumbs.current}</BreadcrumbItem>
        </>
      </BreadcrumbsContainer>
    </p>
  );
};

export interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  React.useEffect(() => {
    document.body.className = 'not-logged-in';
  }, []);

  return (
    <>
      <section className="container topbar anonymous">
        <AnonymousBreadcrumbs />
      </section>
      <Content>{children}</Content>
      <ExtensionSlot name="layout-footer" params={{ mode: 'anonymous' }} />
    </>
  );
};
